import styled from "styled-components/macro";

export const LinkButtonWrapper=styled.button`
background:transparent;
cursor: pointer;
outline:none;
border:none ;
font-size:1rem;
`